<template>

	<transition-group 
		name="alert" 
		tag="div"
		enter-active-class="animate__animated animate__fadeIn animate__faster"
		leave-to-class="animate__animated animate__fadeOut animate__faster"
	> 
		<div key="x" class="featherlight" v-if="shouldShow==true" style="display: block;" v-on:click.self="toggleEditBooking()">
			<div class="featherlight-content">
				<button class="featherlight-close-icon featherlight-close" aria-label="Close" v-on:click.self="toggleEditBooking()">✕</button>
				<section class="popup_content featherlight-inner section" style="max-width: 45rem;">
					<div class="constraint">
						<h2>Edit your booking</h2>
						<div class="form_style" style="align-items: center;">
							<template v-if="errors != [] && errors != null && Object.keys(errors).length > 0">
								<template v-if="errors">
									<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>There was a problem with the form submission. Please check the errors below and try again.</span></p>
								</template>
							</template>
							
							<p>
								<label for="booking_name">Booking Name</label>
								<input type="text" id="booking_name" name="booking_name" placeholder="Enter a name for the booking" v-model="booking_name" :class="{ error: errors.booking_name }">
								<span v-if="errors.booking_name" class="validation-error">{{ errors.booking_name[0] }}</span>
							</p>

							<p>
								<label for="banner_image">Banner Image</label>
								<input type="file" ref="fileInput" id="banner_image" name="banner_image" @change="handleFileChange" :class="{ error: errors.banner_image }">
								<span v-if="errors.banner_image" class="validation-error">{{ errors.banner_image[0] }}</span>
							</p>
							<p class="styled_checkboxes" v-if="is_custom_banner">
								<input type="checkbox" value="1" v-model="delete_existing" id="delete_existing"><label for="delete_existing">Delete the existing banner?</label>
							</p>

							<p class="" style="margin-left: auto;">
								<span v-show="submit_disabled" :style="'text-align:center; margin:5px auto; color:' + this.accent">
									<i  class="fas fa-spinner fa-fw fa-2x fa-spin"></i><br/>
									<span>Loading...</span>
								</span>
								<button v-show="submit_disabled == false" type="submit" class="button solid arrow wide medium" v-on:click="submitForm()" :style="'--accent:' + this.accent" :disabled="submit_disabled">Save</button>
							</p>
						</div>
					</div>
				</section>

			</div>
		</div>
	 </transition-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	
	props: [
		'accent',
		'initial_booking_name',
		'initial_banner_thumb',
		'is_custom_banner'
	],

	data: () => {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			uuid: '',
			errors: [],
			shouldShow: false,
			saving: false,
			success: false,
			submit_disabled: false,
			booking_name: '',
			banner_thumb: '',
			banner_image: '',
			delete_existing: false
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
		this.booking_name = this.initial_booking_name;
		this.banner_thumb = this.initial_banner_thumb;
	},

	methods: {

		...mapActions(['addAlert']),

		wrap: function(el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		},

		toggleEditBooking: function(uuid = null){
			if(this.shouldShow==true) {
				this.uuid = null;
				this.shouldShow = false;
				this.errors = [];
			}else{
				this.uuid = uuid
				this.shouldShow = true;
				this.$nextTick(function() {
					// this.getMessages();
				});
			}
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},

		handleFileChange: function(event) {
			this.banner_image = this.$refs.fileInput.files[0];
		},

		submitForm: function() {
			this.submit_disabled = true;
			var self = this;

			const formData = new FormData();
			formData.append('uuid', this.uuid);
			formData.append('booking_name', this.booking_name);
			formData.append('delete_existing', this.delete_existing);
			if (this.banner_image != null) {
				formData.append('banner_image', this.banner_image);
			}
			const headers = {
				'Content-Type': 'multipart/form-data',
			};
			axios.post('/ajax/postEditBookingForm', formData, {
				headers
			})
			.then(response => {
				
				if (response.data == 'success') {
					// refresh
					window.location.reload();
					// this.success = true;
					// this.submit_disabled = false;

				}else{
					this.errors = response.data['errors'];
					this.submit_disabled = false;
				}
			})
			.catch(error => {
				if(error.response.status == 422) {
					var errors = error.response.data['errors'];
					this.errors = errors;
					this.submit_disabled = false;
				}
			});
		},

	}
};
</script>